import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Marquee } from "@/components/Marquee";
import { Hero } from "@/components/home/Hero";
import { About } from "@/components/home/About";
import { Guarantees } from "@/components/home/Guarantees";
import { Services } from "@/components/home/Services";
import { Testimonials } from "@/components/home/Testimonials";
import { Faq } from "@/components/home/Faq";
import { FinalCta } from "@/components/home/FinalCta";
import { lenisStore } from "@/lib/lenisStore";

export default function Landing() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      lenisStore.current?.scrollTo(0, { immediate: true });
      return;
    }
    const timer = setTimeout(() => {
      lenisStore.current?.scrollTo(hash, { offset: -88 });
    }, 150);
    return () => clearTimeout(timer);
  }, [hash]);

  return (
    <div data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Guarantees />
        <Services />
        <Testimonials />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}
